import { render, staticRenderFns } from "./EventsCategoriesCreateDialog.vue?vue&type=template&id=165f0925&"
import script from "./EventsCategoriesCreateDialog.vue?vue&type=script&lang=ts&"
export * from "./EventsCategoriesCreateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EventsCategoriesCreateDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports